module.exports = __webpack_public_path__ + "static/img/养老解决方案banner最新1.77cc4adf.png";